import { PrinterPosCheckIcon } from './PrinterPosCheckIcon';

/**
 * author: Colton Wiscombe
 * id 77D3FA23-E73B-4FF9-89A3-D507B44D113C
 * name printer-pos-check
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-check.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptCheckIcon = PrinterPosCheckIcon;
export default PrinterReceiptCheckIcon